import { render, staticRenderFns } from "./OrderMessenger.vue?vue&type=template&id=4d151911"
import script from "./OrderMessenger.vue?vue&type=script&lang=js"
export * from "./OrderMessenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports